import React, { useEffect, useRef } from "react";
import scrollToComponent from "react-scroll-to-component";
import PropTypes from "prop-types";
import { injectIntl } from "react-intl";
import DocumentIcon from "iconsTwoColors/cx/DHL_Preset-US-DocumentEnvelope.svg";
import NonDocumentsIcon from "iconsTwoColors/cx/DHL_Preset-Default-Business.svg";
import { Icon } from "root/libs/ui-components/src";
import { SHIPMENT_TYPES } from "one-time-shipment/src/containers/SpotShipmentPage/constants";
import { DhlText } from "@dhl-official/react-library";
import {
  FreightCardWrapper,
  FreightContent,
  FreightRadioCards,
  StyledHeadline,
} from "../styled";

const ICONS = {
  Documents: DocumentIcon,
  NonDocuments: NonDocumentsIcon,
};
const COPY_ID_PREFIX = "ShipmentLaneComponent.ShipmentTypeSelector";

export const PackageTypeSelector = injectIntl(({ onChange, value, intl }) => {
  const ref = useRef();
  useEffect(() => {
    scrollToComponent(ref.current, {
      offset: -120,
      align: "top",
    });
  }, []);

  return (
    <div className="mx-wrapper">
      <StyledHeadline
        weight="800"
        priority={2}
        ref={ref}
        headlineDisplayType="h"
        className="grid-maxWidthInner no-padding"
      >
        {intl.formatMessage({ id: `${COPY_ID_PREFIX}.Title` })}
        <br />
        <DhlText weight="400">
          {intl.formatMessage({ id: `${COPY_ID_PREFIX}.SubTitle` })}
        </DhlText>
      </StyledHeadline>

      <FreightCardWrapper
        className="no-padding"
        dimension="biDimensional"
        stepperEnabled
      >
        <FreightContent
          dimension="biDimensional"
          spanMobile="12"
          columnStartMobile="1"
          spanTablet="12"
          columnStartTablet="1"
          spanDesktop="10"
          columnStart="2"
        >
          <FreightRadioCards
            name="shipmentType"
            value={value}
            onChange={onChange}
            options={Object.keys(SHIPMENT_TYPES).map((key) => ({
              label: intl.formatMessage({
                id: `${COPY_ID_PREFIX}.${key}`,
              }),
              value: SHIPMENT_TYPES[key],
              required: true,
              icon: (
                <Icon
                  data-testid={ICONS[key].id}
                  icon={ICONS[key]}
                  useAs="decorative"
                  height={{ desktop: "60px" }}
                />
              ),
              description: intl.formatMessage({
                id: `${COPY_ID_PREFIX}.${key}.Description`,
              }),
            }))}
          />
        </FreightContent>
      </FreightCardWrapper>
    </div>
  );
});
PackageTypeSelector.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.string,
};
